import React from 'react';
import { Zap, Droplets, PhoneCall, Plus, Trash2, MapPin, CheckCircle2 } from 'lucide-react';

const SocioServiciosSection = ({ servicios = [], onChange }) => {
    
    const tiposDisponibles = [
        { id: 'ANDE', label: 'Energía Eléctrica (ANDE)', icon: Zap, color: 'text-amber-500', bg: 'bg-amber-50', border: 'border-amber-100', placeholder: 'Nro. de NIS' },
        { id: 'ESSAP', label: 'Agua Potable (ESSAP)', icon: Droplets, color: 'text-blue-500', bg: 'bg-blue-50', border: 'border-blue-100', placeholder: 'Nro. de Cuenta / ISS' },
        { id: 'COPACO', label: 'Telefonía / Internet (COPACO)', icon: PhoneCall, color: 'text-rose-500', bg: 'bg-rose-50', border: 'border-rose-100', placeholder: 'Nro. de Línea' }
    ];

    const handleAdd = (tipo) => {
        const nuevo = {
            tipoServicio: tipo.id,
            identificadorServicio: '',
            titularNombre: '',
            latitud: '',
            longitud: ''
        };
        onChange([...servicios, nuevo]);
    };

    const handleRemove = (index) => {
        const updated = servicios.filter((_, i) => i !== index);
        onChange(updated);
    };

    const handleChange = (index, field, value) => {
        const updated = [...servicios];
        updated[index][field] = value;
        onChange(updated);
    };

    return (
        <div className="space-y-8 animate-premium-in">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 bg-slate-50/50 p-6 rounded-3xl border border-slate-100 shadow-inner mb-8">
                <div>
                    <h3 className="text-[12px] font-black uppercase tracking-[0.2em] text-slate-800 flex items-center gap-3">
                        <MapPin className="w-5 h-5 text-uni-teal" /> Servicios del Domicilio
                    </h3>
                    <p className="text-[10px] text-slate-400 font-bold uppercase mt-2 tracking-widest">Registre los suministros básicos asociados a la ubicación</p>
                </div>
                
                <div className="flex gap-2">
                    {tiposDisponibles.map(t => {
                        const yaExiste = servicios.some(s => s.tipoServicio === t.id);
                        if (yaExiste) return null;
                        
                        return (
                            <button
                                key={t.id}
                                type="button"
                                onClick={() => handleAdd(t)}
                                className={`flex items-center gap-2 px-6 py-3 bg-white border border-slate-200 rounded-2xl text-[9px] font-black uppercase tracking-widest hover:bg-slate-900 hover:text-white transition-all shadow-xl hover:scale-105 active:scale-95`}
                            >
                                <Plus className="w-4 h-4" /> {t.id}
                            </button>
                        );
                    })}
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {servicios.map((s, idx) => {
                    const infoTipo = tiposDisponibles.find(t => t.id === s.tipoServicio) || tiposDisponibles[0];
                    const Icon = infoTipo.icon;

                    return (
                        <div key={idx} className="group relative p-8 bg-white rounded-[2.5rem] border border-slate-200 shadow-2xl shadow-slate-900/5 hover:border-uni-teal/30 transition-all animate-premium-in">
                            <button 
                                type="button"
                                onClick={() => handleRemove(idx)}
                                className="absolute -top-3 -right-3 w-10 h-10 bg-rose-500 text-white rounded-xl flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all shadow-xl hover:scale-110 active:scale-90 z-10"
                            >
                                <Trash2 className="w-5 h-5" />
                            </button>

                            <div className="flex items-center gap-6 mb-8">
                                <div className={`p-5 ${infoTipo.bg} rounded-3xl border ${infoTipo.border} shadow-sm`}>
                                    <Icon className={`w-8 h-8 ${infoTipo.color}`} />
                                </div>
                                <div className="flex-1">
                                    <span className="text-[11px] font-black uppercase text-slate-900 tracking-widest block">{infoTipo.label}</span>
                                    <div className="flex items-center gap-2 mt-2">
                                        <CheckCircle2 className="w-3 h-3 text-emerald-500" />
                                        <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">Suministro Verificado</span>
                                    </div>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="relative">
                                    <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-2 block ml-1">Identificador (NIS / Cuenta)</label>
                                    <input 
                                        type="text"
                                        value={s.identificadorServicio || ""}
                                        onChange={(e) => handleChange(idx, 'identificadorServicio', e.target.value)}
                                        placeholder={infoTipo.placeholder}
                                        className="w-full px-6 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-xs font-bold text-slate-700 placeholder:text-slate-300 focus:bg-white focus:border-uni-teal focus:ring-4 focus:ring-uni-teal/5 transition-all outline-none"
                                    />
                                </div>

                                <div className="relative">
                                    <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-2 block ml-1">Nombre del Titular</label>
                                    <input 
                                        type="text"
                                        value={s.titularNombre || ""}
                                        onChange={(e) => handleChange(idx, 'titularNombre', e.target.value)}
                                        placeholder="Ej: Juan Pérez"
                                        className="w-full px-6 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-xs font-bold text-slate-700 placeholder:text-slate-300 focus:bg-white focus:border-uni-teal focus:ring-4 focus:ring-uni-teal/5 transition-all outline-none"
                                    />
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-2 block ml-1">Latitud</label>
                                        <input 
                                            type="text"
                                            value={s.latitud || ""}
                                            onChange={(e) => handleChange(idx, 'latitud', e.target.value)}
                                            placeholder="-25.123..."
                                            className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-[10px] font-bold text-slate-500 outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-2 block ml-1">Longitud</label>
                                        <input 
                                            type="text"
                                            value={s.longitud || ""}
                                            onChange={(e) => handleChange(idx, 'longitud', e.target.value)}
                                            placeholder="-57.456..."
                                            className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-[10px] font-bold text-slate-500 outline-none"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            
            {servicios.length === 0 && (
                <div className="p-20 text-center border-2 border-dashed border-slate-100 rounded-[3rem] bg-slate-50/20">
                    <MapPin className="w-12 h-12 text-slate-200 mx-auto mb-6" />
                    <p className="text-slate-400 text-[10px] font-black uppercase tracking-[0.2em]">No hay servicios registrados aún</p>
                    <p className="text-slate-300 text-[9px] font-bold uppercase tracking-widest mt-2">Agregue ANDE, ESSAP o COPACO usando los botones superiores</p>
                </div>
            )}
        </div>
    );
};

export default SocioServiciosSection;
